/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BankStatus } from '../../models/bank-status';
import { ContractDetailsDtoApiResponse } from '../../models/contract-details-dto-api-response';

export interface UpdateStatusCustomerBankAsync$Plain$Params {
  id: number;
  bankId: number;
  status: BankStatus;
}

export function updateStatusCustomerBankAsync$Plain(http: HttpClient, rootUrl: string, params: UpdateStatusCustomerBankAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, updateStatusCustomerBankAsync$Plain.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('bankId', params.bankId, {});
    rb.path('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDetailsDtoApiResponse>;
    })
  );
}

updateStatusCustomerBankAsync$Plain.PATH = '/api/customer/{id}/bank/{bankId}/status/{status}';
